import {
  getErrorMessage,
  breakfastType,
  dinnerType,
  getTimes,
  compareEventsByStartTime,
} from '../../utils';
import {
  REQUEST_AVAILABLE_ADDONS,
  RECEIVE_AVAILABLE_ADDONS,
  SET_AVAILABLE_ADDONS_FAILURE,
  CLEAR_AVAILABLE_ADDONS_ERROR_MESSAGE,
  ON_SAVE_DINING,
} from '../constants/dinings';

const getAvailableSlots = ({ addons = [] }) => {
  const breakfastSlots = addons.filter(({ AddonCategory }) => AddonCategory === breakfastType);
  const dinnerSlots = addons.filter(({ AddonCategory }) => AddonCategory === dinnerType);

  const allSlots = [...breakfastSlots, ...dinnerSlots]
    .map(({ Addon, AddonCategory }) => {
      const { name, comments, code } = Addon;
      const { startTime, endTime } = getTimes(comments);
      return !startTime || !endTime ? {} : { startTime, endTime, name, type: AddonCategory, code };
    })
    .filter(slot => !!slot.startTime);

  if (allSlots.length === 0) return [];

  allSlots.sort(compareEventsByStartTime);
  return allSlots;
};

const initialState = {
  isFetching: false,
  wasCalled: false,
  bookedBreakfast: {},
  bookedDinner: {},
  diningSlots: [],
  rawDinings: [],
  errorMessage: '',
};

const dinings = (state = initialState, action) => {
  switch (action.type) {
    case REQUEST_AVAILABLE_ADDONS: {
      return { ...state, isFetching: true };
    }
    case RECEIVE_AVAILABLE_ADDONS: {
      const { addons = {}, bookedBreakfast, bookedDinner } = action;
      const { Units: units = [] } = addons;
      const [firstUnit = {}] = units;
      const availableSlots = getAvailableSlots(firstUnit);
      return {
        ...state,
        isFetching: false,
        bookedBreakfast,
        bookedDinner,
        diningSlots: availableSlots,
        errorMessage: '',
        wasCalled: true,
        rawDinings: firstUnit.addons,
      };
    }
    case SET_AVAILABLE_ADDONS_FAILURE: {
      const { error } = action;
      const errorMessage = getErrorMessage(error);
      return { ...state, isFetching: false, errorMessage, wasCalled: true };
    }
    case CLEAR_AVAILABLE_ADDONS_ERROR_MESSAGE: {
      return { ...state, errorMessage: '' };
    }
    case ON_SAVE_DINING: {
      return { ...state, wasCalled: false };
    }
    default:
      return state;
  }
};

export default dinings;
